import React from 'react';
import { styled } from '@mui/material';
import { Text } from 'components/Text';
import { GMITokenLogo } from 'components/ImageComponent';

/********************  Styled Components  ********************/
const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  width: 'max-content',
  height: 48,
  borderRadius: 8,
  border: `1px solid ${theme.palette.border.decorative}`,
  backgroundColor: theme.palette.background.tertiary,
  translate: '24px',
  padding: '0 40px 0 16px',
  gap: 10,

  '@media (max-width: 550px)': {
    display: 'none',
  },
}));

/********************  Main Component  ********************/
const GmiAmount = ({ amount }) => {
  // TODO: Re-enable dollar value display with dynamic pricing from API
  // GMI value at $0.01 temporarily - will pull from API in future
  // const gmiPrice = 0.01;

  // Handle different data types for amount (string, number, etc.)
  // eslint-disable-next-line no-unused-vars
  const amountString = String(amount || '0');

  // Parse amount with any suffix (M, K, B, T, etc.)
  // eslint-disable-next-line no-unused-vars
  const parseAmountWithSuffix = (str) => {
    // Remove commas and spaces
    const cleanStr = str.replace(/[,\s]/g, '');

    // Extract number and suffix
    const match = cleanStr.match(/^([\d.]+)([A-Za-z]*)$/);
    if (!match) {
      return 0;
    }

    const [, numberPart, suffix] = match;
    const baseNumber = parseFloat(numberPart) || 0;

    // Define multipliers
    const multipliers = {
      K: 1000,
      M: 1000000,
      B: 1000000000,
      T: 1000000000000,
    };

    // Apply multiplier if suffix exists
    const multiplier = multipliers[suffix.toUpperCase()] || 1;
    return baseNumber * multiplier;
  };

  // TODO: Re-enable dollar value calculation with dynamic pricing from API
  // const numericAmount = parseAmountWithSuffix(amountString);
  // const totalValue = numericAmount * gmiPrice;

  // const formattedValue = totalValue.toLocaleString('en-US', {
  //   style: 'currency',
  //   currency: 'USD',
  //   minimumFractionDigits: totalValue >= 1000 ? 0 : 2,
  //   maximumFractionDigits: totalValue >= 1000 ? 0 : 2,
  // });

  return (
    <Container>
      <GMITokenLogo />
      <Text main="true" fs={16} fw={600} lh={24}>
        {/* TODO: Re-enable dollar value display with dynamic pricing from API */}
        {amount} GMI {/* ({formattedValue}) */}
      </Text>
    </Container>
  );
};

export default GmiAmount;
